// FAQ.jsx
import { useState, useEffect, useRef } from "react";
import "./FAQ.css";

const FAQ_DATA = [
  {
    q: "Is Grow Biz International legal and registered?",
    badge: "Verified",
    answer:
      "Yes. Grow Biz International is a fully registered and legally operating portfolio management and real estate investment company in Pakistan.",
    points: [
      "Registered under Pakistani company law with valid business documentation",
      "Compliant with SECP guidelines for investment firms",
      "All investment activities are backed by real estate assets",
      "Transparent income structure with documented agreements",
    ],
  },
  // {
  //   q: "How do I withdraw my earnings?",
  //   badge: "Withdrawals",
  //   answer:
  //     "Withdrawals are simple and processed directly to your bank account or mobile wallet.",
  //   points: [
  //     "Login to your member dashboard and click Withdraw",
  //     "Enter the amount — minimum withdrawal is PKR 1,000",
  //     "Choose your method: Bank Transfer, JazzCash, or EasyPaisa",
  //     "Processing time is 24–72 business hours",
  //   ],
  // },
  // {
  //   q: "What is the minimum investment amount?",
  //   badge: "Packages",
  //   answer:
  //     "We offer multiple packages to suit every budget, starting from a very affordable entry point.",
  //   points: [
  //     "Starter — PKR 10,000 | 2% monthly ROI",
  //     "Silver — PKR 50,000 | 2.5% monthly ROI",
  //     "Gold — PKR 100,000 | 3% monthly ROI",
  //     "Platinum — PKR 500,000+ | 3.5% monthly ROI",
  //   ],
  // },
  // {
  //   q: "How does the referral system work?",
  //   badge: "Referrals",
  //   answer:
  //     "Every member receives a unique referral link. When someone registers and activates using your link, you earn instantly.",
  //   points: [
  //     "Share your referral link via WhatsApp, SMS, or social media",
  //     "Earn 10% direct bonus when your referral activates",
  //     "Also earn Level Income from their team — up to 5 levels deep",
  //     "No cap on the number of referrals you can make",
  //   ],
  // },
  // {
  //   q: "When and how often are profits paid?",
  //   badge: "Payouts",
  //   answer:
  //     "ROI income is credited to your wallet every month. Referral bonuses are instant upon activation.",
  //   points: [
  //     "ROI — credited on the 1st of every month",
  //     "Referral bonus — instant, within minutes of activation",
  //     "Level income — credited every Monday",
  //     "Profit sharing — quarterly (March, June, Sep, Dec)",
  //   ],
  // },
  {
    q: "Can I have multiple accounts?",
    badge: "Policy",
    answer:
      "No. Each person is allowed only one active account verified by their CNIC. Multiple accounts lead to permanent suspension.",
    points: [
      "One account per CNIC number",
      "Family members may each have their own separate account",
      "Contact support if you need to update your details",
    ],
  },
  {
    q: "Is my investment safe? What backs it?",
    badge: "Security",
    answer:
      "All member funds are deployed into real estate assets across Karachi, Lahore, and Islamabad — tangible physical assets that hold value.",
    points: [
      "Funds invested in commercial & residential properties",
      "Monthly rental income forms the base of ROI payments",
      "Properties are professionally managed and insured",
      "Financial statements available to members on request",
    ],
  },
  {
    q: "How do I contact support?",
    badge: "Support",
    answer: "Our team is available 7 days a week across multiple channels.",
    points: [
      "WhatsApp Support: +92-300-GROWBIZ",
      "Email: support@growbizint.com",
      "Office visits available in Karachi, Lahore & Islamabad",
    ],
  },
];

function FAQParticles() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    let W, H, raf;
    const resize = () => {
      W = c.offsetWidth || 800;
      H = c.offsetHeight || 900;
      c.width = W;
      c.height = H;
    };
    resize();
    window.addEventListener("resize", resize);
    const dust = Array.from({ length: 120 }, () => ({
      x: Math.random() * 1200,
      y: Math.random() * 1200,
      r: Math.random() * 1.1 + 0.2,
      o: Math.random() * 0.45 + 0.08,
      vx: (Math.random() - 0.5) * 0.1,
      vy: (Math.random() - 0.5) * 0.1,
      f: Math.random() * Math.PI * 2,
    }));
    const bokeh = Array.from({ length: 8 }, () => ({
      x: Math.random() * 1200,
      y: Math.random() * 1200,
      r: Math.random() * 35 + 12,
      o: Math.random() * 0.08 + 0.02,
      vx: (Math.random() - 0.5) * 0.05,
      vy: (Math.random() - 0.5) * 0.04,
      p: Math.random() * Math.PI * 2,
    }));
    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      bokeh.forEach((b) => {
        b.x += b.vx;
        b.y += b.vy;
        b.p += 0.006;
        if (b.x < -50) b.x = W + 50;
        if (b.x > W + 50) b.x = -50;
        if (b.y < -50) b.y = H + 50;
        if (b.y > H + 50) b.y = -50;
        const op = b.o * (0.6 + 0.4 * Math.sin(b.p));
        const g = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.r);
        g.addColorStop(0, `rgba(212,175,55,${op})`);
        g.addColorStop(1, "rgba(212,175,55,0)");
        ctx.beginPath();
        ctx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
        ctx.fillStyle = g;
        ctx.fill();
      });
      dust.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.f += 0.022;
        if (p.x < 0) p.x = W;
        if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H;
        if (p.y > H) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(212,175,55,${p.o * (0.5 + 0.5 * Math.sin(p.f))})`;
        ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);
  return <canvas ref={canvasRef} className="faq-particles" />;
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="faq-section" id="faq">
      <FAQParticles />
      <div className="faq-inner">
        <div className="faq-head">
          <span className="faq-label">Got Questions?</span>
          <h2 className="faq-title">
            Frequently Asked <span className="faq-gold">Questions</span>
          </h2>
          <div className="faq-gline" />
        </div>

        <div className="faq-list">
          {FAQ_DATA.map((item, i) => (
            <div
              key={i}
              className={`faq-item${openIndex === i ? " open" : ""}`}
              style={{ animationDelay: `${i * 0.07}s` }}
            >
              <button className="faq-q" onClick={() => toggle(i)}>
                <span className="faq-num">0{i + 1}</span>
                <span className="faq-qtext">{item.q}</span>
                <span className="faq-icon">
                  <span className="faq-icon-cross" />
                </span>
              </button>
              <div className="faq-body">
                <div className="faq-ans">
                  <span className="faq-badge">{item.badge}</span>
                  <p>{item.answer}</p>
                  <ul>
                    {item.points.map((pt, j) => (
                      <li key={j}>{pt}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-cta">
          <h3>Still have questions?</h3>
          <p>
            Our team is ready to walk you through everything before you invest.
          </p>
          <button className="faq-btn-primary">Talk to an Advisor</button>
          <button className="faq-btn-outline">WhatsApp Us</button>
        </div>
      </div>
    </section>
  );
}
